import React from "react";

const LetterXIcon = ({ color = "black" }) => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.16602 8L7.91602 10.5L11.666 8"
        stroke={color}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.1663 16.3334H2.49967C2.05765 16.3334 1.63372 16.1578 1.32116 15.8453C1.0086 15.5327 0.833008 15.1088 0.833008 14.6667V6.33341C0.833008 5.89139 1.0086 5.46746 1.32116 5.1549C1.63372 4.84234 2.05765 4.66675 2.49967 4.66675H13.333C13.775 4.66675 14.199 4.84234 14.5115 5.1549C14.8241 5.46746 14.9997 5.89139 14.9997 6.33341V8.00008"
        stroke={color}
        stroke-linecap="round"
      />
      <path
        d="M17 10.0002L13 14.0002M13 10.0002L17 14.0002"
        stroke={color}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default LetterXIcon;
